import React from 'react';
import PropTypes from 'prop-types';

const IfRender = (props) =>
     props.condition ? <>{props.children}</> : <>{props.otherwise}</> || null;

IfRender.propTypes = {
     condition: PropTypes.any,
     children: PropTypes.any,
     otherwise: PropTypes.any
};
export default IfRender;
